import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './client';
/** Admin: list all rule versions across all formats. */
export function useAdminListRules() {
    return useQuery({
        queryKey: ['admin', 'rules'],
        queryFn: () => api.request('/api/admin/rules'),
        staleTime: 30_000,
    });
}
/** Admin: publish a new version for the given format. */
export function usePublishRule() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (format) => api.request('/api/admin/rules/publish', {
            method: 'POST',
            body: JSON.stringify({ format }),
        }),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'rules'] }),
    });
}
/** Admin: re-generate AI summary for a specific rule. */
export function useRegenerateSummary() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (ruleId) => api.request(`/api/admin/rules/${ruleId}/regenerate-summary`, { method: 'POST' }),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'rules'] }),
    });
}
/** Public: version history for a format (includes AI summaries). */
export function usePublicRuleHistory(format) {
    return useQuery({
        queryKey: ['public', 'rules', format, 'history'],
        queryFn: () => api.request(`/api/public/rules/${format}/history`),
        staleTime: 30_000,
        enabled: format.length > 0,
    });
}
